
import React from 'react';
import VideoDialog from '@/components/VideoDialog';

const VideoSection = () => {
  return (
    <section className="py-6 sm:py-8 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 
          className="text-xl sm:text-2xl font-bold text-gray-900 mb-2"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          ¿Cómo funciona MigranteAmigo?
        </h2>
        <p 
          className="text-base text-gray-600 mb-6"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          Mira este video de 90 segundos.
        </p>
        
        <div className="flex justify-center">
          <div className="w-full max-w-2xl aspect-video rounded-lg shadow-sm border-2 border-gray-200">
            <VideoDialog 
              embedded={true}
              videoSrc="https://res.cloudinary.com/dnbk7yjo4/video/upload/v1750794590/Migrante_App_Intro_Video_Vs3_1_1_f1akmg.mp4" 
              videoTitle="¿Cómo usar MigranteAmigo?"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
